// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/Messenger/Messenger.css */

.messenger-container {
    color: white;
    font-family: Verdana, Arial, Helvetica, sans-serif;
    position: relative;
    width: 100%;
    padding: 20px;
    padding-top: 40px;
  }
  
.download-section {
  position: absolute;
  top: 5px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 6px;
  background-color: #f5f5f5;
  transition: background-color 0.2s ease;
  z-index: 10; /* Ensure it's above other elements */
}

.download-section:hover {
  background-color: #EF6F53;
}

.download-icon {
  width: 20px;
  height: 20px;
}

.download-text {
  font-size: 12px;
  color: #333;
  font-weight: 500;
}

  .sendinggg_twos{
    display: flex;
    position: relative;
    width: 100%;
  }
  
  .form-containerr {
    width: 55%;
    margin: auto;
    padding: 0.5rem;
    background-color: #1e1e1e;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  
  .form-section {
    margin-bottom: 0.5rem;
  }
  
  .form-label {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.1rem;
    display: block;
    text-align: left;
    color: #EF6F53;
  }
  
  .form-input,
  .form-textarea {
    width: 100%;
    padding: 0.25rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 0.8rem;
    background-color: #253e5897;
    color: white;
    outline: none;
  }
  
  .form-textarea {
    height: 100px;
  }
  
  .form-input:focus,
  .form-textarea:focus {
    border-color: #EF6F53;
    color: white;
  }
  
  .form-button {
    background-color: #EF6F53;
    color: white;
    border: none;
    width: 30%;
    margin: auto;
    padding: 0.25rem;
    font-size: 0.8rem;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}
  
  .form-button:hover {
    background-color: #d95b47;
  }

  .file-upload-container {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
  }

  .file-input {
    max-width: 94.5px;
    padding: 0.125rem;
  }

  .file-name-input {
    flex: 1 1;
    background-color: #1e1e1e;
    cursor: default;
  }

  .file-types {
    font-size: 12px;
    font-weight: normal;
  }

.header-buttonsss {
    padding: 15px;
    background-color: #1e1e1e;
    border-radius: 8px;
    color: white;
    /* max-width: 300px; */
}

.header-buttonsss p {
    font-size: 14px;
    color: #d95b47;
    font-weight: bold;
}

.button-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.header-button {
    padding: 8px 10px;
    background-color: #d95b47;
    border: none;
    border-radius: 10px;
    color: white;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    transition: all 0.2s ease;
}

.header-button:hover {
    background-color: #EF6F53;
}

/* Disabled state styles */
.form-input:disabled,
.file-input:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.7;
}

/* Template placeholder styles */
.form-textarea::placeholder {
    color: #999;
}

.message-input-container,
.caption-input-container {
    background-color: #253e5897;
    border-radius: 10px;
    padding: 8px;
}

.formatting-buttons {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}

.format-btn {
    background-color: #253e58;
    color: white;
    border: 1px solid white;
    border-radius: 4px;
    padding: 4px 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    min-width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.format-btn:hover {
  border: 1px solid #EF6F53;
}

.format-btn:active {
    transform: scale(0.95);
}

.message-input,
.caption-input {
    width: 100%;
    padding: 0.25rem;
    border: 1px solid white;
    border-radius: 6px;
    min-height: 100px;
    font-size: 12px;
    line-height: 1.5;
    background-color: #253e5897;
    color: white;
    overflow-y: auto;
    outline: none;
    text-align: left;
}

.message-input[contenteditable]:empty:before,
.caption-input[contenteditable]:empty:before {
    content: attr(placeholder);
    color: rgba(255, 255, 255, 0.6);
    pointer-events: none;
    font-style: italic;
}

.message-input:focus,
.caption-input:focus {
    outline: none;
    border-color: #EF6F53;
    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.25);
}

/* WhatsApp Preview Styles */
.whatsapp-preview-container {
    width: 30%;
    background-color: #1e1e1e;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    padding: 0.5rem;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .whatsapp-preview-header {
    background-color: #075e54;
    color: white;
    padding: 5px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  .whatsapp-preview-body {
    background-color: #1d4057;
    flex-grow: 1;
    margin: 1rem;
    padding: 1rem;
    border-radius: 2rem;
    overflow-y: auto;
    min-height: 400px;
    position: relative;
  }

  .whatsapp-message-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-bottom: 10px;
    padding: 0.5rem;
  }

  .whatsapp-message {
    background-color: #005c4b;
    color: white;
    padding: 10px;
    border-radius: 7px;
    max-width: 285px;
    word-wrap: break-word;
    position: relative;
    text-align: left;
    margin-bottom: 5px;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    line-height: 1.4;
  }

  .whatsapp-message::after {
    content: '';
    position: absolute;
    right: -7.5px;
    top: 0;
    width: 0;
    height: 0;
    border-top: 10px solid #005c4b;
    border-right: 10px solid transparent;
  }

  .whatsapp-media-container {
    background-color: #005c4b;
    border-radius: 7px;
    max-width: 240px;
    overflow: hidden;
    margin-bottom: 5px;
  }

  .whatsapp-media-preview {
    width: 100%;
    max-height: 250px;
    object-fit: contain;
    background-color: #2a2a2a;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .whatsapp-media-preview img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  .whatsapp-media-caption {
    padding: 5px;
    color: white;
    word-wrap: break-word;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    line-height: 1.25;
  }

  /* WhatsApp text formatting styles */
  .whatsapp-bold {
    font-weight: bold;
  }

  .whatsapp-italic {
    font-style: italic;
  }

  .whatsapp-bold-italic {
    font-weight: bold;
    font-style: italic;
  }

  .whatsapp-timestamp {
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.6);
    text-align: right;
    margin-top: 2px;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  .whatsapp-preview-placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #8696a0;
    text-align: center;
    width: 80%;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  /* Media file type icons */
  .media-type-icon {
    width: 40px;
    height: 40px;
    margin: 20px auto;
    display: block;
  }

@media (max-width: 600px) {

  .sendinggg_twos{
      display: flex;
      flex-direction: column;
  }
  .form-container {
    width:90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/Messenger/Messenger.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;IACI,YAAY;IACZ,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;AAEF;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,WAAW,EAAE,qCAAqC;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;EAEE;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,sCAAsC;AAC1C;;EAEE;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;AAEF;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,gCAAgC;AAChC;IACI,WAAW;AACf;;AAEA;;IAEI,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,0BAA0B;IAC1B,+BAA+B;IAC/B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA,4BAA4B;AAC5B;IACI,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAA2D;IAC3D,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,2DAA2D;IAC3D,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,2DAA2D;EAC7D;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,2DAA2D;EAC7D;;EAEA,0BAA0B;EAC1B;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;;AAEF;;EAEE;MACI,aAAa;MACb,sBAAsB;EAC1B;EACA;IACE,SAAS;EACX;AACF","sourcesContent":["/* src/components/routes/Forms/Messenger/Messenger.css */\n\n.messenger-container {\n    color: white;\n    font-family: Verdana, Arial, Helvetica, sans-serif;\n    position: relative;\n    width: 100%;\n    padding: 20px;\n    padding-top: 40px;\n  }\n  \n.download-section {\n  position: absolute;\n  top: 5px;\n  right: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 6px;\n  background-color: #f5f5f5;\n  transition: background-color 0.2s ease;\n  z-index: 10; /* Ensure it's above other elements */\n}\n\n.download-section:hover {\n  background-color: #EF6F53;\n}\n\n.download-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.download-text {\n  font-size: 12px;\n  color: #333;\n  font-weight: 500;\n}\n\n  .sendinggg_twos{\n    display: flex;\n    position: relative;\n    width: 100%;\n  }\n  \n  .form-containerr {\n    width: 55%;\n    margin: auto;\n    padding: 0.5rem;\n    background-color: #1e1e1e;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  }\n  \n  .form-section {\n    margin-bottom: 0.5rem;\n  }\n  \n  .form-label {\n    font-size: 1rem;\n    font-weight: bold;\n    margin-bottom: 0.1rem;\n    display: block;\n    text-align: left;\n    color: #EF6F53;\n  }\n  \n  .form-input,\n  .form-textarea {\n    width: 100%;\n    padding: 0.25rem;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 0.8rem;\n    background-color: #253e5897;\n    color: white;\n    outline: none;\n  }\n  \n  .form-textarea {\n    height: 100px;\n  }\n  \n  .form-input:focus,\n  .form-textarea:focus {\n    border-color: #EF6F53;\n    color: white;\n  }\n  \n  .form-button {\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    width: 30%;\n    margin: auto;\n    padding: 0.25rem;\n    font-size: 0.8rem;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n  \n  .form-button:hover {\n    background-color: #d95b47;\n  }\n\n  .file-upload-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n  }\n\n  .file-input {\n    max-width: 94.5px;\n    padding: 0.125rem;\n  }\n\n  .file-name-input {\n    flex: 1;\n    background-color: #1e1e1e;\n    cursor: default;\n  }\n\n  .file-types {\n    font-size: 12px;\n    font-weight: normal;\n  }\n\n.header-buttonsss {\n    padding: 15px;\n    background-color: #1e1e1e;\n    border-radius: 8px;\n    color: white;\n    /* max-width: 300px; */\n}\n\n.header-buttonsss p {\n    font-size: 14px;\n    color: #d95b47;\n    font-weight: bold;\n}\n\n.button-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.header-button {\n    padding: 8px 10px;\n    background-color: #d95b47;\n    border: none;\n    border-radius: 10px;\n    color: white;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: bold;\n    transition: all 0.2s ease;\n}\n\n.header-button:hover {\n    background-color: #EF6F53;\n}\n\n/* Disabled state styles */\n.form-input:disabled,\n.file-input:disabled {\n    background-color: #f5f5f5;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/* Template placeholder styles */\n.form-textarea::placeholder {\n    color: #999;\n}\n\n.message-input-container,\n.caption-input-container {\n    background-color: #253e5897;\n    border-radius: 10px;\n    padding: 8px;\n}\n\n.formatting-buttons {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.format-btn {\n    background-color: #253e58;\n    color: white;\n    border: 1px solid white;\n    border-radius: 4px;\n    padding: 4px 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 14px;\n    min-width: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.format-btn:hover {\n  border: 1px solid #EF6F53;\n}\n\n.format-btn:active {\n    transform: scale(0.95);\n}\n\n.message-input,\n.caption-input {\n    width: 100%;\n    padding: 0.25rem;\n    border: 1px solid white;\n    border-radius: 6px;\n    min-height: 100px;\n    font-size: 12px;\n    line-height: 1.5;\n    background-color: #253e5897;\n    color: white;\n    overflow-y: auto;\n    outline: none;\n    text-align: left;\n}\n\n.message-input[contenteditable]:empty:before,\n.caption-input[contenteditable]:empty:before {\n    content: attr(placeholder);\n    color: rgba(255, 255, 255, 0.6);\n    pointer-events: none;\n    font-style: italic;\n}\n\n.message-input:focus,\n.caption-input:focus {\n    outline: none;\n    border-color: #EF6F53;\n    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.25);\n}\n\n/* WhatsApp Preview Styles */\n.whatsapp-preview-container {\n    width: 30%;\n    background-color: #1e1e1e;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n    padding: 0.5rem;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .whatsapp-preview-header {\n    background-color: #075e54;\n    color: white;\n    padding: 5px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n  }\n\n  .whatsapp-preview-body {\n    background-color: #1d4057;\n    flex-grow: 1;\n    margin: 1rem;\n    padding: 1rem;\n    border-radius: 2rem;\n    overflow-y: auto;\n    min-height: 400px;\n    position: relative;\n  }\n\n  .whatsapp-message-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    margin-bottom: 10px;\n    padding: 0.5rem;\n  }\n\n  .whatsapp-message {\n    background-color: #005c4b;\n    color: white;\n    padding: 10px;\n    border-radius: 7px;\n    max-width: 285px;\n    word-wrap: break-word;\n    position: relative;\n    text-align: left;\n    margin-bottom: 5px;\n    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    line-height: 1.4;\n  }\n\n  .whatsapp-message::after {\n    content: '';\n    position: absolute;\n    right: -7.5px;\n    top: 0;\n    width: 0;\n    height: 0;\n    border-top: 10px solid #005c4b;\n    border-right: 10px solid transparent;\n  }\n\n  .whatsapp-media-container {\n    background-color: #005c4b;\n    border-radius: 7px;\n    max-width: 240px;\n    overflow: hidden;\n    margin-bottom: 5px;\n  }\n\n  .whatsapp-media-preview {\n    width: 100%;\n    max-height: 250px;\n    object-fit: contain;\n    background-color: #2a2a2a;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .whatsapp-media-preview img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    display: block;\n  }\n\n  .whatsapp-media-caption {\n    padding: 5px;\n    color: white;\n    word-wrap: break-word;\n    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    line-height: 1.25;\n  }\n\n  /* WhatsApp text formatting styles */\n  .whatsapp-bold {\n    font-weight: bold;\n  }\n\n  .whatsapp-italic {\n    font-style: italic;\n  }\n\n  .whatsapp-bold-italic {\n    font-weight: bold;\n    font-style: italic;\n  }\n\n  .whatsapp-timestamp {\n    font-size: 0.7rem;\n    color: rgba(255, 255, 255, 0.6);\n    text-align: right;\n    margin-top: 2px;\n    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  }\n\n  .whatsapp-preview-placeholder {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #8696a0;\n    text-align: center;\n    width: 80%;\n    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  }\n\n  /* Media file type icons */\n  .media-type-icon {\n    width: 40px;\n    height: 40px;\n    margin: 20px auto;\n    display: block;\n  }\n\n@media (max-width: 600px) {\n\n  .sendinggg_twos{\n      display: flex;\n      flex-direction: column;\n  }\n  .form-container {\n    width:90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
